<template lang="html">
  <div class="cron" :val="bindVal" :class="heightClass" style="overflow:auto;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="秒" name="s">
        <second-and-minute v-model="sVal" lable="秒"></second-and-minute>
      </el-tab-pane>
      <el-tab-pane label="分" name="m">
        <second-and-minute v-model="mVal" lable="分"></second-and-minute>
      </el-tab-pane>
      <el-tab-pane label="时" name="h">
        <hour v-model="hVal" lable="时"></hour>
      </el-tab-pane>
      <el-tab-pane label="日" name="d">
        <day v-model="dVal" lable="日" ref="day"></day>
      </el-tab-pane>
      <el-tab-pane label="月" name="month">
        <month v-model="monthVal" lable="月"></month>
      </el-tab-pane>
      <el-tab-pane label="周" name="week">
        <week v-model="weekVal" lable="周" ref="week"></week>
      </el-tab-pane>
      <el-tab-pane label="年" name="year">
        <year v-model="yearVal" lable="年"></year>
      </el-tab-pane>
    </el-tabs>
    <!-- table -->
    <el-table
      :data="tableData"
      size="mini"
      border
      style="width: 100%;"
      :span-method="arraySpanMethod"
      class="mt-10px"
    >
      <el-table-column prop="text" label=""></el-table-column>
      <el-table-column label="秒" prop="sVal"></el-table-column>
      <el-table-column label="分" prop="mVal"></el-table-column>
      <el-table-column label="时" prop="hVal"></el-table-column>
      <el-table-column label="日" prop="dVal"></el-table-column>
      <el-table-column label="月" prop="monthVal"></el-table-column>
      <el-table-column label="周" prop="weekVal"></el-table-column>
      <el-table-column label="年" prop="yearVal"></el-table-column>
    </el-table>
    <el-popover placement="right" width="620" trigger="click">
      <h4>功能介绍</h4>
      <hr />
      <div>
        <p>
          <span><span>常用表达式例子</span></span>
        </p>
        <p>
          &emsp;&emsp;<span
            ><span style="line-height:18px;color:#0000FF;"
              ><span style="line-height:18px;color:#000000;">（1）</span></span
            ><span><span style="line-height:18px;color:#0000FF;">0/2 * * * * ?</span></span
            >&nbsp;&nbsp;</span
          >&nbsp;表示每2秒 执行任务
        </p>
        <p>
          &emsp;&emsp;<span
            ><span style="line-height:18px;color:#0000FF;"
              ><span style="line-height:18px;color:#000000;">（1）</span></span
            ><span><span style="line-height:18px;color:#0000FF;">0 0/2 * * * ?&nbsp;</span></span
            >&nbsp;&nbsp;</span
          >&nbsp;表示每2分钟 执行任务
        </p>
        <p>
          &emsp;&emsp;<span
            ><span style="line-height:18px;color:#0000FF;"
              ><span style="line-height:18px;color:#000000;">（1）</span></span
            ><span><span style="line-height:18px;color:#0000FF;">0 0 2 1 * ?</span></span
            >&nbsp;&nbsp;</span
          >&nbsp;表示在每月的1日的凌晨2点调整任务
        </p>
        <p>
          &emsp;&emsp;<span style="line-height:18px;color:#0000FF;"
            ><span style="line-height:18px;color:#000000;">（2）</span></span
          ><span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 ? * MON-FRI</span>&nbsp;</span
          >&nbsp; 表示周一到周五每天上午10:15执行作业
        </p>
        <p>
          &emsp;&emsp;（3）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 ? 6L 2002-2006</span></span
          >&nbsp;&nbsp; 表示2002-2006年的每个月的最后一个星期五上午10:15执行作
        </p>
        <p>
          &emsp;&emsp;（4）<span
            ><span style="line-height:18px;color:#0000FF;">0 0 10,14,16 * * ?</span></span
          >&nbsp;&nbsp;&nbsp;每天上午10点，下午2点，4点&nbsp;
        </p>
        <p>
          &emsp;&emsp;（5）<span
            ><span style="line-height:18px;color:#0000FF;">0 0/30 9-17 * * ?</span></span
          >&nbsp;&nbsp; 朝九晚五工作时间内每半小时&nbsp;
        </p>
        <p>
          &emsp;&emsp;（6）<span
            ><span style="line-height:18px;color:#0000FF;">0 0 12 ? * WED</span></span
          >&nbsp;&nbsp; &nbsp;表示每个星期三中午12点&nbsp;
        </p>
        <p>
          &emsp;&emsp;（7）<span
            ><span style="line-height:18px;color:#0000FF;">0 0 12 * * ?</span></span
          >&nbsp;&nbsp;&nbsp;每天中午12点触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（8）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 ? * * &nbsp;</span></span
          >&nbsp;&nbsp;每天上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（9）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 * * ?</span></span
          >&nbsp;&nbsp; &nbsp; 每天上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（10）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 * * ?</span>&nbsp;</span
          >&nbsp; &nbsp;每天上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（11）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 * * ? 2005</span></span
          >&nbsp;&nbsp; &nbsp;2005年的每天上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（12）<span
            ><span style="line-height:18px;color:#0000FF;">0 * 14 * * ?</span></span
          >&nbsp;&nbsp; &nbsp; 在每天下午2点到下午2:59期间的每1分钟触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（13）<span
            ><span style="line-height:18px;color:#0000FF;">0 0/5 14 * * ?</span></span
          >&nbsp;&nbsp; &nbsp;在每天下午2点到下午2:55期间的每5分钟触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（14）<span
            ><span style="line-height:18px;color:#0000FF;">0 0/5 14,18 * * ?</span></span
          >&nbsp;&nbsp; &nbsp; 在每天下午2点到2:55期间和下午6点到6:55期间的每5分钟触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（15）<span
            ><span style="line-height:18px;color:#0000FF;">0 0-5 14 * * ?</span>&nbsp;</span
          >&nbsp; &nbsp;在每天下午2点到下午2:05期间的每1分钟触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（16）<span
            ><span style="line-height:18px;color:#0000FF;">0 10,44 14 ? 3 WED</span></span
          >&nbsp;&nbsp; &nbsp;每年三月的星期三的下午2:10和2:44触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（17）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 ? * MON-FRI</span>&nbsp;</span
          >&nbsp; &nbsp;周一至周五的上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（18）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 15 * ?</span>&nbsp;</span
          >&nbsp; &nbsp;每月15日上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（19）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 L * ?</span>&nbsp;</span
          >&nbsp; &nbsp;每月最后一日的上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（20）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 ? * 6L</span>&nbsp;</span
          >&nbsp; &nbsp;每月的最后一个星期五上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（21）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 ? * 6L 2002-2005</span></span
          >&nbsp;&nbsp; 2002年至2005年的每月的最后一个星期五上午10:15触发&nbsp;
        </p>
        <p>
          &emsp;&emsp;（22）<span
            ><span style="line-height:18px;color:#0000FF;">0 15 10 ? * 6#3</span></span
          >&nbsp;&nbsp; 每月的第三个星期五上午10:15触发
        </p>
      </div>
      <div style="color:#1890ff;" class="cur-pointer mt-10px" slot="reference">常用表达式例子</div>
    </el-popover>
  </div>
</template>

<script>
import FnCron from '@/assets/js/cron'
import SecondAndMinute from './secondAndMinute'
import hour from './hour'
import day from './day'
import month from './month'
import week from './week'
import year from './year'

export default {
  props: {
    value: {
      type: String,
    },
  },
  mixins: [FnCron],
  data() {
    return {
      heightClass: 'h-585px',
      //
      activeName: 's',
      sVal: '',
      mVal: '',
      hVal: '',
      dVal: '',
      monthVal: '',
      weekVal: '',
      yearVal: '',
      weekValue: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '日',
      },
      description: '',
    }
  },
  watch: {
    value() {
      this.updateVal()
    },
    dVal(val) {
      if (val === '?' && this.weekVal === '?') {
        this.$message.warning('日期与星期不可以同时为“不指定”')
        this.weekVal = '*'
        this.$refs.day.week = '1'
      }
      if (val !== '?' && this.weekVal !== '?') {
        this.$message.warning('日期与星期必须有一个为“不指定”')
        this.weekVal = '?'
        this.$refs.weekVal.type = '5'
      }
    },
    weekVal(val) {
      if (val === '?' && this.dVal === '?') {
        this.$message.warning('日期与星期不可以同时为“不指定”')
        this.dVal = '*'
        this.$refs.day.type = '1'
      }
      if (val !== '?' && this.dVal !== '?') {
        this.$message.warning('日期与星期必须有一个为“不指定”')
        this.dVal = '?'
        this.$refs.day.type = '5'
      }
    },
    bindVal(val) {
      if (val) {
        // console.log(val)
        this.description = this.toDescription(val)
      }
    },
    activeName(val) {
      // console.log(val, '++++++++++++')
      if (val === 's') {
        this.heightClass = 'h-585px'
      } else if (val === 'm') {
        this.heightClass = 'h-585px'
      } else if (val === 'h') {
        this.heightClass = 'h-500px'
      } else if (val === 'd') {
        this.heightClass = 'h-650px'
      } else if (val === 'month') {
        this.heightClass = 'h-505px'
      } else if (val === 'week') {
        this.heightClass = 'h-565px'
      } else if (val === 'year') {
        this.heightClass = 'h-360px'
      }
    },
  },
  computed: {
    tableData() {
      return [
        {
          text: '表达式字段',
          sVal: this.sVal,
          mVal: this.mVal,
          hVal: this.hVal,
          dVal: this.dVal,
          monthVal: this.monthVal,
          weekVal: this.weekVal,
          yearVal: this.yearVal,
        },
        {
          text: 'Cron表达式',
          sVal: this.bindVal,
          mVal: '',
          hVal: '',
          dVal: '',
          monthVal: '',
          weekVal: '',
          yearVal: '',
        },
      ]
    },
    bindVal() {
      if (!this.dVal && !this.weekVal) {
        return ''
      }
      const v = `${this.sVal} ${this.mVal} ${this.hVal} ${this.dVal} ${this.monthVal} ${this.weekVal} ${this.yearVal}`
      if (v !== this.value) {
        this.$emit('input', v)
      }
      return v
    },
  },
  methods: {
    updateVal() {
      if (!this.value) {
        return
      }
      const arrays = this.value.split(' ')
      this.sVal = arrays[0]
      this.mVal = arrays[1]
      this.hVal = arrays[2]
      this.dVal = arrays[3]
      this.monthVal = arrays[4]
      this.weekVal = arrays[5]
      this.yearVal = arrays[6]
    },
    // 合并行
    arraySpanMethod({ rowIndex, columnIndex }) {
      if (rowIndex === 1 && columnIndex === 1) {
        return [1, 7]
      }
      return [1, 1]
    },
  },
  created() {
    this.updateVal()
  },
  components: {
    SecondAndMinute,
    hour,
    day,
    month,
    week,
    year,
  },
}
</script>

<style lang="css" scoped>

.cron {
  text-align: left;
  padding: 10px;
  /* background: #fff; */
  border: 1px solid #dcdfe6;
  /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04); */
}

</style>
